import React from "react";
import "./table.css";
import Button from "../../widgets/button";
import ReactHtmlParser from "html-react-parser";
import { generateExcel } from "../table/table.utils";

export interface headerType {
  label: string;
  style?: {
    alignment?: {
      textAlign?: "left" | "center" | "right";
      verticalAlign?: "top" | "middle" | "bottom";
      color?: string;
    };
  };
  headerColor?: string;
  exlStyle?: {
    alignment?: {
      horizontal?: "left" | "center" | "right";
    };
    width?: number;
  };
}

interface TableProps {
  id?: string;
  tableHeading?: string;
  classNames?: string;
  classNameTable?: string;
  headers: headerType[];
  data: string[][];
  actionButtons?: React.ReactNode;
  exportExcel?: boolean;
  fileName?: string;
  buttonsClass?: ButtonProps[];
  onClickButton1?: (id1: number) => void;
  onClickButton2?: (id1: number) => void;
  onClickButton3?: (id1: number) => void;
  onClickButton4?: (id1: number) => void;
}

const Table: React.FC<TableProps> = ({
  id,
  tableHeading,
  headers,
  classNames,
  classNameTable,
  data,
  exportExcel,
  fileName,
  buttonsClass,
  onClickButton1,
  onClickButton2,
  onClickButton3,
  onClickButton4,
}) => {
  // Prepare Excel data
  const excelData: string[][] = [];
  if (data) {
    data.forEach((row, i) => {
      excelData[i] = [];
      headers.forEach((header, index) => {
        excelData[i].push(row[index]);
      });
    });
  }

  return (
    <>
      {exportExcel ? (
        <div
          className={`py-2 d-flex align-items-center ${tableHeading ? "tableHeading" : ""} justify-content-between`}
        >
          <div><h6 className="table-heading">{tableHeading}</h6></div>
          <Button
            data="Export"
            className="btn btn-sm approveBtn ml-auto"
            onClick={() => generateExcel(headers, excelData, fileName)}
          />{" "}
        </div>
      ) : null}

      <div className={`bcmk-table table-responsive fixTableHead ${classNameTable}`}>
        <table className={`table table-striped ${classNames} responsive`}>
          <thead>
            <tr>
              {headers.map((header, index) =>
                buttonsClass && index === 0 ? null : (
                  <th
                    key={index}
                    style={{
                      ...(header.style?.alignment ?? { textAlign: "left" }),
                      ...(header.headerColor ? { color: header.headerColor } : {}),
                    }}
                  >
                    {header.label}
                  </th>
                )
              )}
              {buttonsClass?.map((btn, classindex) => (
                <th key={classindex}>{btn["btnColHeading"]}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => {
                  if (buttonsClass && cellIndex === 0) return null;
                  if (cellIndex > headers.length - 1) return null;

                  const alignment = headers[cellIndex].style?.alignment;
                  const color = alignment?.color;
                  const cellStyle = { ...alignment };
                  if (color) delete (cellStyle as any).color;

                  return (
                    <td
                      key={cellIndex}
                      className={cellIndex === 1 ? "scheduled-date" : ""}
                      style={cellStyle}
                      data-label={headers[cellIndex].label}
                    >
                      {typeof cell === "string" && color ? (
                        <span style={{ color }}>{ReactHtmlParser(cell)}</span>
                      ) : typeof cell === "string" ? (
                        ReactHtmlParser(cell)
                      ) : (
                        cell
                      )}
                    </td>
                  );
                })}

                {buttonsClass?.map((btn, classindex) => {
                  const isButton = btn.btnType === "Button";
                  const btnValue = row[headers.length + classindex];

                  const renderButton = (onClick?: (id: number) => void) =>
                    btnValue === "1" ? (
                      <button
                        key={`${rowIndex}-${classindex}`}
                        className={btn.btnClassName}
                        onClick={() => onClick?.(parseInt(row[0]))}
                      >
                        {btn.btnName}
                      </button>
                    ) : btnValue ? (
                      <div className="w-1 text-success" style={{ paddingTop: "10px" }}>
                        {btnValue}
                      </div>
                    ) : null;

                  const renderImg = (onClick?: (id: number) => void) => (
                    <img
                      key={`${rowIndex}-${classindex}`}
                      className={btn.btnClassName}
                      alt="Map Icon"
                      onClick={() => onClick?.(parseInt(row[0]))}
                      src={btn.btnSrc}
                    />
                  );

                  switch (classindex) {
                    case 0:
                      return (
                        <td key={classindex} className={id === "scheduledJobs" ? "" : "w-1"}>
                          {isButton ? renderButton(onClickButton1) : renderImg(onClickButton1)}
                        </td>
                      );
                    case 1:
                      return (
                        <td key={classindex} className={id === "scheduledJobs" ? "" : "w-1"}>
                          {isButton ? renderButton(onClickButton2) : renderImg(onClickButton2)}
                        </td>
                      );
                    case 2:
                      return (
                        <td key={classindex} className={id === "scheduledJobs" ? "" : "w-1"}>
                          {isButton ? renderButton(onClickButton3) : renderImg(onClickButton3)}
                        </td>
                      );
                    case 3:
                      return (
                        <td key={classindex} className={id === "scheduledJobs" ? "" : "w-1"}>
                          {isButton ? renderButton(onClickButton4) : renderImg(onClickButton4)}
                        </td>
                      );
                    default:
                      return (
                        <td key={classindex} className={id === "scheduledJobs" ? "schtd" : "w-1"}>
                          {isButton ? renderButton(onClickButton2) : renderImg(onClickButton2)}
                        </td>
                      );
                  }
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
